'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dProduct20 from "./scala.-Product20.js";
var $p;
/** @constructor */
function $c_T20(_1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20) {
  this.oJ = null;
  this.oU = null;
  this.oW = null;
  this.oX = null;
  this.oY = null;
  this.oZ = null;
  this.p0 = null;
  this.p1 = null;
  this.p2 = null;
  this.oK = null;
  this.oL = null;
  this.oM = null;
  this.oN = null;
  this.oO = null;
  this.oP = null;
  this.oQ = null;
  this.oR = null;
  this.oS = null;
  this.oT = null;
  this.oV = null;
  this.oJ = _1;
  this.oU = _2;
  this.oW = _3;
  this.oX = _4;
  this.oY = _5;
  this.oZ = _6;
  this.p0 = _7;
  this.p1 = _8;
  this.p2 = _9;
  this.oK = _10;
  this.oL = _11;
  this.oM = _12;
  this.oN = _13;
  this.oO = _14;
  this.oP = _15;
  this.oQ = _16;
  this.oR = _17;
  this.oS = _18;
  this.oT = _19;
  this.oV = _20;
}
export { $c_T20 as $c_T20 };
$p = $c_T20.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_T20;
/** @constructor */
function $h_T20() {
}
export { $h_T20 as $h_T20 };
$h_T20.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.n = (function() {
  return 20;
});
$p.g = (function(n) {
  return $j_scala$002e$002dProduct20.$f_s_Product20__productElement__I__O(this, n);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, 1328807075, true);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_T20) && ((((((((((((((((((($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oJ, x$0.oJ) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oU, x$0.oU)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oW, x$0.oW)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oX, x$0.oX)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oY, x$0.oY)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oZ, x$0.oZ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p0, x$0.p0)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p1, x$0.p1)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.p2, x$0.p2)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oK, x$0.oK)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oL, x$0.oL)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oM, x$0.oM)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oN, x$0.oN)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oO, x$0.oO)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oP, x$0.oP)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oQ, x$0.oQ)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oR, x$0.oR)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oS, x$0.oS)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oT, x$0.oT)) && $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().c(this.oV, x$0.oV))));
});
$p.o = (function() {
  return "Tuple20";
});
$p.b = (function() {
  return (((((((((((((((((((((((((((((((((((((((("(" + this.oJ) + ",") + this.oU) + ",") + this.oW) + ",") + this.oX) + ",") + this.oY) + ",") + this.oZ) + ",") + this.p0) + ",") + this.p1) + ",") + this.p2) + ",") + this.oK) + ",") + this.oL) + ",") + this.oM) + ",") + this.oN) + ",") + this.oO) + ",") + this.oP) + ",") + this.oQ) + ",") + this.oR) + ",") + this.oS) + ",") + this.oT) + ",") + this.oV) + ")");
});
function $isArrayOf_T20(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.eK)));
}
export { $isArrayOf_T20 as $isArrayOf_T20 };
var $d_T20 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_T20, "scala.Tuple20", ({
  eK: 1,
  b: 1,
  c: 1,
  rT: 1,
  a: 1
}));
export { $d_T20 as $d_T20 };
